import { FC } from 'react';
import Image from 'next/image';

import HeaderLInks from '@components/HeaderLInks';

import styles from './Header.module.scss';

interface HeaderProps {
  isMobile?: boolean;
  routes: {
    name: string;
    path: string;
    logo: string;
  }[];
}

const Header: FC<HeaderProps> = ({ isMobile, routes }) => {
  return (
    <header className={styles.header}>
      <div className={styles.logoWrapper}>
        <Image
          src={'/assets/logo.svg'}
          alt="logo"
          width={140}
          height={48}
          className={styles.logo}
        />
      </div>
      {!isMobile && <HeaderLInks routes={routes} />}
    </header>
  );
};

export default Header;
